import { useEffect, useState, RefObject } from 'react';

export type TimerRef = ReturnType<typeof setInterval> | null;

interface IProps {
  timerRef: React.MutableRefObject<TimerRef>;
  setActiveKey: React.Dispatch<React.SetStateAction<number>>;
  stopAct: React.MutableRefObject<boolean>;
  tabsTotal: number;
}

export const clearTimer = (timerRef: React.MutableRefObject<TimerRef>) => {
  if (timerRef.current) {
    clearInterval(timerRef.current);
    timerRef.current = null;
  }
};

export const handlePlay = ({ timerRef, setActiveKey, stopAct, tabsTotal }: IProps) => {
  clearTimer(timerRef);
  if (stopAct.current) return;
  timerRef.current = setInterval(() => {
    setActiveKey(activeKey => (activeKey + 1) % tabsTotal);
  }, 3000);
};

interface UseElementInViewportProps {
  targetElement: RefObject<HTMLElement>;
  onEnterViewport: () => void;
  onStayInViewport: () => void;
}

const useElementInViewport = ({ targetElement, onEnterViewport, onStayInViewport }: UseElementInViewportProps) => {
  const [isInViewport, setIsInViewport] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (targetElement.current) {
        const rect = targetElement.current.getBoundingClientRect();
        // viewPortHeight 兼容所有浏览器
        const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        const newIsInViewport = rect.top <= viewPortHeight && rect.bottom >= 0;

        if (newIsInViewport && !isInViewport) {
          // 进入可视区域时执行一次
          onEnterViewport();
        }

        if (newIsInViewport) {
          // 停留在可视区域时执行
          onStayInViewport();
        }

        setIsInViewport(newIsInViewport);
      }
    };

    window.addEventListener('scroll', handleScroll);
    // 初始化时也检查一次
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [targetElement, onEnterViewport, onStayInViewport, isInViewport]);
};

export default useElementInViewport;
